import React from 'react'
import { isEmpty } from 'lodash'
import { Row, Col } from 'reactstrap'
import ApiService from '../../../data/services/ApiService'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'

const Suppliers = ({
  data,
  itemAction,
}) => {
  return (
    <React.Fragment>
      <Row>
        {!isEmpty(data) && data.map((item, key) => (
          <Col
            key={`${item.id}-${key}`}
            onClick={() => itemAction(item)}
            className="col-6 col-md-3 col-lg-3"
          >
            <div
              className="rounded-circle m-product m-product-5 text-center"
              style={{ height: 135, width: 140, cursor: 'pointer' }}
            >
              <img
                className="avatar-lg"
                src={!isEmpty(item.logotipo) ? `${ApiService.getUrlBaseStorage()}suppliers/${item.logotipo}` : getUrlOfDefaultProductImage()}
                alt=""
                style={{ objectFit: 'contain', marginTop: '20px' }}
                width={150}
              />
            </div>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  )
}

export default Suppliers
